module.exports = __webpack_public_path__ + "static/media/pko.b03ab06f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pko.svg
// module id = 647
// module chunks = 0